import { render } from "./CookiePolicy.vue?vue&type=template&id=e6b5922c&scoped=true"
import script from "./CookiePolicy.vue?vue&type=script&lang=js"
export * from "./CookiePolicy.vue?vue&type=script&lang=js"

import "./CookiePolicy.vue?vue&type=style&index=0&id=e6b5922c&scoped=true&lang=css"

import exportComponent from "C:\\laragon\\www\\Dividenduitkering-Toets\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e6b5922c"]])

export default __exports__